/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 1
// module chunks = 1